
import { CommonModule } from "@angular/common";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormControl, Validators,FormArray,FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { ApiService } from "src/app/service/api.service";
import { NotificationService } from 'src/app/service/notification.service';
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
// 	center: google.maps.LatLngLiteral = { lat: 40.7128, lng: -74.0060 }; // Example: New York
//   zoom = 15;

	center: google.maps.LatLngLiteral = { lat: 28.4525, lng: 77.0295 };  // Coordinates from Geocoding API
  zoom = 15;
  @Input("config") config: any = {
		type: 1,
		length: 6,
		cssClass: "custom",
		back: {
			stroke: "#2F9688",
			solid: "#f2efd2",
		},
		font: {
			color: "#000000",
			size: "35px",
		},
	};
  captch_input: any = null;
	code: any = null;
	resultCode: any = null;
	checkCaptchaValue: boolean = false;

  constructor(private http: HttpClient,public api:ApiService,private notification : NotificationService,private toastr: ToastrService,private snackBar: MatSnackBar) { }

  @Output() captchaCode = new EventEmitter();

	

	ngOnInit(): void {
		// this.snackBar.open('Test Snackbar', 'Close', { duration: 3000 });

		this.createCaptcha()
		this.getCoordinates('1st Floor, AVA Court, Malibu Towne, Sohna Road, Gurugram, Haryana 122018')
      .subscribe((response: any) => {
        if (response.results && response.results.length > 0) {
          const location = response.results[0].geometry.location;
          this.center = {
            lat: location.lat,
            lng: location.lng
          };
        }
      });
	}


	RegisterForm = new FormGroup({
		id:new FormControl(''),
		name: new FormControl('', [Validators.required]),
		email: new FormControl('', [Validators.required, Validators.email]),
		mobile: new FormControl('', [
			Validators.required,
			Validators.pattern('^[0-9]{10}$'), // Ensures exactly 10 digits, no characters
		  ]),
		subject: new FormControl(''),
		message: new FormControl(''),
		capicha: new FormControl('', [this.validateCaptcha.bind(this)]),
		status: new FormControl(),
	  });

	getCoordinates(address: string) {
		const encodedAddress = encodeURIComponent(address);
		const apiKey = 'AIzaSyA2X5k3eCukSpbJq5FZnfPaFdQXVLOEpfc';  // Replace with your actual API key
		const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`;
	
		return this.http.get(geocodeUrl);
	  }


	// onSubmit() {
	// 	if (this.captch_input !== this.resultCode) {
	// 		this.showError();
	// 		this.captch_input = "";
	// 		this.reloadCaptcha();
	// 	} else {
	// 		console.log(this.captch_input,this.resultCode)
			
	// 	}
	// }

	
	
	  validateCaptcha(control: FormControl) {
		if (control.value && control.value.toUpperCase() !== this.resultCode) {
		  return { invalidCaptcha: true };
		}
		return null;
	  }

	  get capicha() {
		return this.RegisterForm.get('capicha');
	  }

	//   get mobile() {
	// 	return this.RegisterForm.get('mobile');
	//   }
	  

	onSubmit() {
		console.log('this.RegisterForm', this.RegisterForm);

		if (this.capicha.errors) {
			this.snackBar.open('Invalid CAPTCHA. Please try again.', 'Close', {
			  duration: 4000,
			  panelClass: ['error-snackbar'],
			});
			return;
		  }

		//   if (this.mobile.errors) {
		// 	this.snackBar.open('Please Enter The Mobile Number.', 'Close', {
		// 	  duration: 4000,
		// 	  panelClass: ['error-snackbar'],
		// 	});
		// 	return;
		//   }

		  if (this.RegisterForm.invalid) {
			// Mark all controls as touched to show validation messages
			this.RegisterForm.markAllAsTouched();
			return;
		}
	  
		if (this.RegisterForm.valid) {

			

		this.RegisterForm.value.status = 1;
		  this.api
			.postAPI(
			  environment.API_URL + "master/contact/crud",
			  this.RegisterForm.value
			)
			.subscribe(
			  (res) => {
				// Check if the response status is 1 or 2 and display the appropriate message
				if (res.status === 1) {
				  // Show success message using MatSnackBar
				  this.snackBar.open(res.message, 'Close', {
					duration: 5000, // Duration in milliseconds
					horizontalPosition: 'center',
					verticalPosition: 'bottom',
					panelClass: ['success-snackbar'], // Success message style
				  });
				  this.RegisterForm.reset();
				} else if (res.status === 2) {
				  // Show error message using MatSnackBar
				  this.snackBar.open(res.message, 'Close', {
					duration: 5000, // Duration in milliseconds
					horizontalPosition: 'center',
					verticalPosition: 'bottom',
					panelClass: ['error-snackbar'], // Error message style
				  });
				}
			  },
			  (error) => {
				// Optional: Show error if there's an issue with the API call
				this.snackBar.open('An error occurred!', 'Close', {
				  duration: 4000,
				  horizontalPosition: 'center',
				  verticalPosition: 'bottom',
				  panelClass: ['error-snackbar'],
				});
			  }
			);
		}
	  }
	  
	

	
  

	checkCaptcha() {
		if (this.captch_input === this.resultCode) {

			this.checkCaptchaValue = true;
			return true;
		} else {
			this.checkCaptchaValue = false;
			return false;
		}
	
	}

	createCaptcha() {
		switch (this.config.type) {
			case 1:
				let char =
					Math.random()
						.toString(24)
						.substring(2, this.config.length) +
					Math.random().toString(24).substring(2, 4);
				this.code = this.resultCode = char.toUpperCase();
				break;
			case 2: 
		
		}
		setTimeout(() => {
			let captcahCanvas: any = document.getElementById("captcahCanvas");
			var ctx = captcahCanvas.getContext("2d");
			ctx.fillStyle = this.config.back.solid;
			ctx.fillRect(0, 0, captcahCanvas.width, captcahCanvas.height);

			ctx.beginPath();

			captcahCanvas.style.letterSpacing = 10 + "px";
			captcahCanvas.style.height = 95 + "px";
			ctx.font = this.config.font.size + " " + this.config.font.family;
			ctx.fillStyle = this.config.font.color;
			ctx.textBaseline = "middle";
			ctx.fillText(this.code, 50, 80);
			if (this.config.back.stroke) {
				ctx.strokeStyle = this.config.back.stroke;
				for (var i = 0; i < 150; i++) {
					ctx.moveTo(Math.random() * 300, Math.random() * 300);
					ctx.lineTo(Math.random() * 300, Math.random() * 300);
				}
				ctx.stroke();
			}

		}, 100);
	}

	reloadCaptcha(): void {
		this.createCaptcha();
	}
// @Input("config") config: any = {
// 	type: 1,
// 	length: 6,
// 	cssClass: "custom",
// 	back: {
// 		stroke: "#2F9688",
// 		solid: "#f2efd2",
// 	},
// 	font: {
// 		color: "#000000",
// 		size: "35px",
// 	},
// };
// captch_input: any = null;
// code: any = null;
// resultCode: any = null;
// checkCaptchaValue: boolean = false;

// constructor() { }

// @Output() captchaCode = new EventEmitter();



// ngOnInit(): void {
// 	this.createCaptcha()
// }

// onSubmit() {
// 	// Validate captcha input
// 	if (this.captch_input !== this.resultCode) {
// 		this.showError();
// 		this.captch_input = "";
// 		this.reloadCaptcha();
// 	} else {
// 		console.log(this.captch_input,this.resultCode)
// 		// Proceed with form submission
// 		// ...
// 	}
// }

// showError() {
// 	// Show error message using Toastr service or any other method
// }


// // Function to check if captcha input is correct
// checkCaptcha() {
// 	if (this.captch_input === this.resultCode) {
// 		//console.log('resultCode',this.resultCode);
// 		//console.log('same value');
// 		this.checkCaptchaValue = true;
// 		return true;
// 	} else {
// 		this.checkCaptchaValue = false;
// 		//console.log('different value');
// 		return false;
// 	}
// 	// return true;
// 	// Implement captcha validation logic
// }

// // Function to create a new captcha
// createCaptcha() {
// 	switch (this.config.type) {
// 		case 1: // only alpha numaric degits to type
// 			let char =
// 				Math.random()
// 					.toString(24)
// 					.substring(2, this.config.length) +
// 				Math.random().toString(24).substring(2, 4);
// 			this.code = this.resultCode = char.toUpperCase();
// 			break;
// 		case 2: // solve the calculation
// 		// let num1 = Math.floor(Math.random() * 99);
// 		// let num2 = Math.floor(Math.random() * 9);
// 		// let operators = ['+','-'];
// 		// let operator = operators[(Math.floor(Math.random() * operators.length))];
// 		// //this.code =  num1+operator+num2+'=?';
// 		// //this.resultCode = (operator == '+')? (num1+num2):(num1-num2);
// 		// break;
// 	}
// 	setTimeout(() => {
// 		let captcahCanvas: any = document.getElementById("captcahCanvas");
// 		var ctx = captcahCanvas.getContext("2d");
// 		ctx.fillStyle = this.config.back.solid;
// 		ctx.fillRect(0, 0, captcahCanvas.width, captcahCanvas.height);

// 		ctx.beginPath();

// 		captcahCanvas.style.letterSpacing = 15 + "px";
// 		ctx.font = this.config.font.size + " " + this.config.font.family;
// 		ctx.fillStyle = this.config.font.color;
// 		ctx.textBaseline = "middle";
// 		ctx.fillText(this.code, 40, 50);
// 		if (this.config.back.stroke) {
// 			ctx.strokeStyle = this.config.back.stroke;
// 			for (var i = 0; i < 150; i++) {
// 				ctx.moveTo(Math.random() * 300, Math.random() * 300);
// 				ctx.lineTo(Math.random() * 300, Math.random() * 300);
// 			}
// 			ctx.stroke();
// 		}

// 		// this.captchaCode.emit(char);
// 	}, 100);
// 	// Generate captcha code and render it on canvas
// }

// // Function to reload captcha
// reloadCaptcha(): void {
// 	this.createCaptcha();
// 	// Reload captcha by generating a new code
// }
}
